import useLocalStorageLib from 'use-local-storage'

type Options<T> = Partial<{
  serializer: (object: T | undefined) => string;
  parser: (val: string) => T | undefined;
  logger: (error: any) => void;
  syncData: boolean;
}>

type Setter<T> = React.Dispatch<React.SetStateAction<T | undefined>>;

/**
 * okay, right. so this custom hook wraps the useLocalStorage hook. but why? why woud we want to do that and not just use the hook as-is?
 * so the useLocalStorge hook is a great hook, but it has a problem. its SSR protection isn't compatible with vite's and it will always fire on the server no matter what we do
 * so we break the rules of hooks by wrapping that hook in a isHydrated conditional. this way, the hook will only run on the client, and not on the server.
 * react doesn't complain about this, because the hook is still being called in the same order, and the same number of times. it's just that it's not being called on the server.
 * the alternative is to re-write the localstorage hook to work better with ssr, but i'll pass on that thanks. BC
 */
export const useLocalStorage = <T>(key: string, defaultValue: T, options?: Options<T>): [T, Setter<T>] => {
  let value = defaultValue, setValue: Setter<T> = () => {}
  if (typeof window !== 'undefined') {
    const res = useLocalStorageLib(key, defaultValue, options)
    value = res[0]
    setValue = res[1]
  }

  return [value, setValue]
}